/**
 * Tour steps that point at marketplace-only UI.
 *
 * A scoped (white-label) affiliate has no "Search new brands" nav item, so a
 * tour step anchored to `#search-brands` would highlight nothing and strand
 * the user. Steps carrying `marketplaceOnly` are dropped for those affiliates.
 */
export interface MarketplaceAwareStep {
  marketplaceOnly?: boolean;
}

// T is left unconstrained on purpose: `MarketplaceAwareStep` has only optional
// members, so constraining to it would trip TypeScript's weak-type check
// against the existing step literals, which share no properties with it.
export function filterMarketplaceSteps<T>(
  steps: T[],
  isMarketplaceHidden: boolean
): T[] {
  if (!isMarketplaceHidden) return steps;
  return steps.filter((step) => !(step as MarketplaceAwareStep).marketplaceOnly);
}
